import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import RegisterModel from '@/app-core/api/models/user/RegisterModel'
import DialogData from '@/app-core/mixins/dialog/dialogData'
import API from '@/app-core/api/Api'
import VueTelInputVuetify from '@/app-theme/components/common/VueTelInputVuetify/VueTelInputVuetify.vue'
import OtpModel from '@/app-core/api/models/otp/OtpModel'

export default {
  name      : 'RegisterDialog',
  components: {VueTelInputVuetify},
  mixins    : [DialogVisible, DialogData],
  props     : {},
  dataModel : RegisterModel,
  data() {
    return {
      step       : 'form',
      otpError   : '',
      otpProgress: {},
      otpModel   : null,
      phone      : {
        number : '',
        valid  : false,
        country: undefined
      }
    }
  },
  computed: {},
  watch   : {
    isVisible(newVal) {
      if (newVal) {
        this.step = 'form'
        this.otpError = ''
        this.$bus.$on('otp:time-start', this.onOtpStart)
        this.$bus.$on('otp:time-progress', this.onOtpProgress)
        this.$bus.$on('otp:time-end', this.onOtpEnd)
      } else {
        this.$bus.$off('otp:time-start', this.onOtpStart)
        this.$bus.$off('otp:time-progress', this.onOtpProgress)
        this.$bus.$off('otp:time-end', this.onOtpEnd)
      }
    }
  },
  methods: {
    onRegisterClick() {
      if (!this.validateForm() || this.isFormSaving) return
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()

      if (this.AppConfig?.Auth?.Otp?.Email || this.AppConfig?.Auth?.Otp?.Sms) {
        this.requestOTP()
      } else {
        this.saveFromData()
      }
    },

    requestOTP() {
      this.isFormSaving = true
      if (this.otpModel) this.otpModel.TimerStop(false)
      this.otpModel = new OtpModel({email: this.model.Email, prefix: this.model.PhonePrefix, phone: this.model.Phone})
      this.otpModel.type = this.AppConfig.Auth.Otp.Email ? 'email' : 'sms'
      const response = this.otpModel.Get()
      this.handleOtpRequestResponse(response)
    },
    handleOtpRequestResponse(result) {
      result
        .then(response => {
          const data = API.responseData(response)
          if (API.isResponseSuccess(response) && !data?.Messages?.Error) {
            this.otpModel.time = data.time
            this.otpModel.TimerStart()
            this.step = 'otp'
          }
        })
        .catch(() => {

        })
        .finally(() => {
          this.isFormSaving = false
        })
    },

    onOtpStart() {
      this.otpError = ''
      this.step = 'otp'
    },

    onOtpProgress(data) {
      this.otpProgress = data
    },

    onOtpEnd() {
      this.otpError = ''
      this.step = 'form'
    },

    onOtpValidate() {
      if (this.otpModel && !this.otpModel.validate()) return

      this.isFormSaving = true
      this.otpError = ''
      const response = this.otpModel.Verify()
      this.handleOtpValidateResponse(response)
    },
    handleOtpValidateResponse(result) {
      result
        .then(response => {
          const data = API.responseData(response)
          if (API.isResponseSuccess(response) && !data?.Messages?.Error) {
            if (this.otpModel) {
              if (this.otpModel.type === 'sms') this.model.PhoneValidated = true
              if (this.otpModel.type === 'email') this.model.EmailValidated = true
              this.otpModel.TimerStop(false)
            }
            this.step = 'form'
            this.saveFromData()
          } else {
            this.otpError = data?.Messages?.Error || this.$t('Common.Error.Generic')
          }
        })
        .catch((error) => {
          const data = API.responseData(error.response)
          this.otpError = data?.Messages?.Error || this.$t('Common.Error.Generic')
        })
        .finally(() => {
          if (this.otpModel) this.otpModel.otp = ''
          this.isFormSaving = false
        })
    },

    onOtpBackClick() {
      if (this.otpModel) {
        this.otpModel.TimerStop(false)
        this.otpModel = null
        this.otpError = ''
      }
      this.step = 'form'
    },

    saveFromData() {
      this.isFormSaving = true

      this.model.Register()
        .then(response => {
          this.handleFormSaveResponse(response)
        })
        .catch(error => {
          this.handleFormSaveResponse(error.response)
        })
        .finally(() => {
          this.isFormSaving = false
        })
    },

    handleFormSaveResponse(response) {
      const data = API.responseData(response) || {}
      const message = data?.Messages

      if (API.isResponseSuccess(response)) {
        if (message.Success) {
          this.formSaveSuccess(data)
          this.autoLogin(response, data)

          this.$bus.$emit('app:show-notification', {
            body   : message.Success,
            type   : 'success',
            icon   : 'mdi-check-circle',
            timeout: 5000
          })
        } else {
          this.formSaveError(message?.Error || message?.Warning || message?.Info, true)
        }
      } else {
        this.formSaveError(message?.Error || message?.Warning || message?.Info, true)
      }
    },

    onLoginClick() {
      this.onCancelButtonClick()
      this.$bus.$emit('login:show-dialog')
    },

    onCancelButtonClick() {
      this.isVisible = false
      this.step = 'form'
    }
  }
}
